// Business Logic Constants using environment variables
export const BUSINESS_CONSTANTS = {
  // Ticket Management
  TICKET: {
    DEFAULT_ASSIGNED_TO: parseInt(process.env.REACT_APP_DEFAULT_ASSIGNED_TO) || 12,
    DEFAULT_REF_TYPE: parseInt(process.env.REACT_APP_DEFAULT_REF_TYPE) || 1,
    DEFAULT_COMM_TYPE_ID: parseInt(process.env.REACT_APP_DEFAULT_COMM_TYPE_ID) || 1,
    DEFAULT_ESCALATION_LEVEL: parseInt(process.env.REACT_APP_DEFAULT_ESCALATION_LEVEL) || 1,
    MAX_DESCRIPTION_LENGTH: parseInt(process.env.REACT_APP_MAX_DESCRIPTION_LENGTH) || 500,
  },
  
  // File Upload
  FILE_UPLOAD: {
    MAX_FILE_SIZE: parseInt(process.env.REACT_APP_MAX_FILE_SIZE, 10) || 5 * 1024 * 1024, // 5MB default; set REACT_APP_MAX_FILE_SIZE in bytes
    MAX_FILES: parseInt(process.env.REACT_APP_MAX_FILES) || 5,
    SUPPORTED_TYPES: [
      'image/jpeg', 
      'image/jpg', 
      'image/png', 
      'image/gif', 
      'application/pdf', 
      'application/msword', 
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
      'text/plain'
    ],
  },
  
  // Pagination
  PAGINATION: {
    DEFAULT_PAGE_SIZE: parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE) || 9,
    DEFAULT_ITEMS_PER_PAGE: parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE) || 9,
  },
  
  // Timeouts
  TIMEOUTS: {
    NAVIGATION_DELAY: parseInt(process.env.REACT_APP_NAVIGATION_DELAY) || 1000,
    SUCCESS_MESSAGE_DELAY: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DELAY) || 5000,
    API_TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,
  },
  
  // Date Ranges
  DATE_RANGES: {
    DEFAULT_DAYS_BACK: parseInt(process.env.REACT_APP_DEFAULT_DAYS_BACK) || 59,
    DEFAULT_MONTHS_BACK: parseInt(process.env.REACT_APP_DEFAULT_MONTHS_BACK) || 1,
  },
  
  // Status Values
  STATUS: {
    SUCCESS: "SUCCESS",
    OK: "OK",
    PENDING: "PENDING",
    FAILED: "FAILED",
  },
  
  // HTTP Status Codes
  HTTP_STATUS_CODES: {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    INVALID_CSRF: 499,
  },
  
  // Error Codes
  ERROR_CODES: {
    MAX_OTP_EXCEEDED: 'MAX_OTP_ALLOWED_FOR_DAY_EXCEEDED',
  },

  /** Session OTP sources — must match BFF SessionOtpReqSource / api-auth OTPReqSource. */
  SESSION_OTP_REQ_SOURCE: {
    GRIEVANCE_EMAIL: 'GRIEVANCE_EMAIL_VERIFICATION',
    GRIEVANCE_MOBILE: 'GRIEVANCE_MOBILE_VERIFICATION',
  },
  SESSION_OTP_REQ_SOURCE_HEADER: 'X-OTP-REQ-SOURCE',
};

export default BUSINESS_CONSTANTS; 